export type BomLineSign = "positive" | "negative";

/** A draft that starts with a minus stays in Negative Adjustments while it is typed. */
export function isNegativeAdjustmentQuantity(quantity: string): boolean {
  const trimmed = quantity.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith("-")) return true;
  const n = Number(trimmed);
  return Number.isFinite(n) && n < 0;
}

/**
 * Keep a quantity draft on its side of the bill.
 * Null means the keystroke does not belong in that section.
 */
export function coerceBomQuantityDraft(raw: string, sign: BomLineSign): string | null {
  if (sign === "positive") {
    if (raw.includes("-")) return null;
    return raw;
  }
  const trimmed = raw.trim();
  if (trimmed === "" || trimmed === "-" || trimmed === "-.") return "-";
  if (trimmed.startsWith("-")) {
    const n = Number(trimmed);
    if (trimmed.endsWith(".") || (Number.isFinite(n) && n < 0)) return trimmed;
    return null;
  }
  if (!/^[\d.]+$/.test(trimmed)) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n === 0) return null;
  return `-${trimmed}`;
}
